import {
  CREATE_ROLE,
  CREATE_ROLE_FAILED,
  CREATE_ROLE_SUCCESS,
  DELETE_ROLE,
  DELETE_ROLE_FAILED,
  DELETE_ROLE_SUCCESS,
  GET_ADMIN_ROLES,
  GET_ADMIN_ROLES_FAILED,
  GET_ADMIN_ROLES_SUCCESS,
  GET_ROLE,
  GET_ROLE_FAILED,
  GET_ROLE_SUCCESS,
  HIDE_ADMIN_ROLE_MODAL,
  HIDE_DELETE_ROLE_MODAL,
  OPEN_ADMIN_ROLE_MODAL,
  OPEN_DELETE_ROLE_MODAL,
  RESET_ROLE,
  UPDATE_ROLE,
  UPDATE_ROLE_FAILED,
  UPDATE_ROLE_SUCCESS,
} from "./actionTypes"

export const getAdminRoles = params => ({
  type: GET_ADMIN_ROLES,
  payload: params,
})

export const getAdminRolesSuccess = response => ({
  type: GET_ADMIN_ROLES_SUCCESS,
  payload: response,
})

export const getAdminRolesFailed = error => ({
  type: GET_ADMIN_ROLES_FAILED,
  payload: error,
})

export const openAdminRoleModal = () => ({
  type: OPEN_ADMIN_ROLE_MODAL,
  payload: {},
})

export const hideAdminRoleModal = () => ({
  type: HIDE_ADMIN_ROLE_MODAL,
  payload: {},
})

export const getRole = params => ({
  type: GET_ROLE,
  payload: params,
})

export const getRoleSuccess = response => ({
  type: GET_ROLE_SUCCESS,
  payload: response,
})

export const getRoleFailed = error => ({
  type: GET_ROLE_FAILED,
  payload: error,
})

export const resetRole = () => ({
  type: RESET_ROLE,
  payload: {},
})

export const createRole = params => ({
  type: CREATE_ROLE,
  payload: params,
})

export const createRoleSuccess = response => ({
  type: CREATE_ROLE_SUCCESS,
  payload: response,
})

export const createRoleFailed = error => ({
  type: CREATE_ROLE_FAILED,
  payload: error,
})

export const updateRole = params => ({
  type: UPDATE_ROLE,
  payload: params,
})

export const updateRoleSuccess = response => ({
  type: UPDATE_ROLE_SUCCESS,
  payload: response,
})

export const updateRoleFailed = error => ({
  type: UPDATE_ROLE_FAILED,
  payload: error,
})

export const openDeleteRoleModal = () => ({
  type: OPEN_DELETE_ROLE_MODAL,
  payload: {},
})

export const hideDeleteRoleModal = () => ({
  type: HIDE_DELETE_ROLE_MODAL,
  payload: {},
})

export const deleteRole = params => ({
  type: DELETE_ROLE,
  payload: params,
})

export const deleteRoleSuccess = response => ({
  type: DELETE_ROLE_SUCCESS,
  payload: response,
})

export const deleteRoleFailed = error => ({
  type: DELETE_ROLE_FAILED,
  payload: error,
})
